//楼层类型
const StoreyType = {
  Home: 1, //首页1
  OperateClassify: 2, //运营分类2
  BaseClassify: 3 //基础分类3
}

//楼层展示方式
const StoreyShowType = {
  PictureStorey: 1, //图片楼层 - 如精选大牌
  GoodsListStorey: 2, //商品列表楼层 - 单格广告
  GoodsListStorey2: 3, //商品列表楼层 - 双格广告
  SingleGoodsStorey: 4, //单品展示楼层 如热销商品 特价专区
  TimesStorey: 5, //计时楼层，如新品抢购
}

export {
  StoreyType,
  StoreyShowType,
}